import { hideLimitOverlay, showLimitOverlay } from "../pages/slideview/content-account-gate-common";
import { isMobile } from '../utils/breakpoints';
import { player } from "./selectors";

const showOrHideOverlayWhenSlideChange = (index, compareSlideIndex) => {
  const shouldBlurReader = player.attr('data-shouldblurreader');

  if (index === compareSlideIndex && shouldBlurReader) {
    hideLimitOverlay();
  }
      
  if (index > compareSlideIndex && shouldBlurReader) {
    showLimitOverlay();
  }
};

export const handlePlayerBlur = (newIndex) => {
  const loadDataForSlide = window.loadDataForSlide;
  if (typeof(loadDataForSlide) === 'function') {
    loadDataForSlide(newIndex);
  }

  showOrHideOverlayWhenSlideChange(newIndex, 0);
};
